import React from 'react';
import { Box, Chip } from '@mui/material';
import {
  TrendingUp as WinsIcon,
  TrendingDown as LossesIcon,
  Remove as DrawsIcon,
  SportsSoccer as GamesIcon
} from '@mui/icons-material';

const TeamStatsChips = ({ 
  team, 
  variant = 'private', // 'private' or 'public'
  size = 'small',
  sx = {}
}) => {
  // Handle both data structures
  const wins = team.wins || 0;
  const draws = team.draws || 0;
  const losses = team.losses || 0;
  const goalsFor = team.goalsFor || team.gf || 0;
  const goalsAgainst = team.goalsAgainst || team.ga || 0;
  const gamesPlayed = team.gamesPlayed || team.played || (wins + draws + losses);
  const goalDifference = team.goalDifference || (goalsFor - goalsAgainst);

  if (variant === 'public') {
    return (
      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', ...sx }}>
        <Chip
          icon={<WinsIcon />}
          label={`${wins} W`}
          size={size}
          clickable={false}
          onClick={() => {}}
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px',
            backgroundColor: '#4caf50',
            color: 'white',
            fontWeight: 'bold',
            '&:hover': { backgroundColor: '#45a049' }
          }}
        />
        <Chip
          icon={<DrawsIcon />}
          label={`${draws} D`}
          size={size}
          clickable={false}
          onClick={() => {}}
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px',
            backgroundColor: '#ff9800',
            color: 'white',
            fontWeight: 'bold',
            '&:hover': { backgroundColor: '#e68900' }
          }}
        />
        <Chip
          icon={<LossesIcon />}
          label={`${losses} L`}
          size={size}
          clickable={false}
          onClick={() => {}}
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px',
            backgroundColor: '#f44336',
            color: 'white',
            fontWeight: 'bold',
            '&:hover': { backgroundColor: '#d32f2f' }
          }}
        />
        <Chip
          icon={<GamesIcon />}
          label={`${gamesPlayed} GP`}
          size={size}
          clickable={false}
          onClick={() => {}}
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px',
            backgroundColor: '#2196f3',
            color: 'white',
            fontWeight: 'bold',
            '&:hover': { backgroundColor: '#1976d2' }
          }}
        />
        <Chip
          label={`GD: ${goalDifference > 0 ? '+' : ''}${goalDifference}`}
          size={size}
          clickable={false}
          onClick={() => {}}
          sx={{ 
            fontSize: '0.7rem', 
            height: '24px',
            backgroundColor: goalDifference >= 0 ? '#4caf50' : '#f44336',
            color: 'white',
            fontWeight: 'bold',
            '&:hover': { backgroundColor: goalDifference >= 0 ? '#45a049' : '#d32f2f' }
          }}
        />
      </Box>
    );
  }

  // Private/TeamsDirectory variant with solid colors
  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', ...sx }}>
      <Chip
        label={`${wins}W`}
        size={size}
        clickable={false}
        onClick={() => {}}
        sx={{ 
          fontSize: '0.7rem', 
          height: '24px',
          backgroundColor: '#4caf50',
          color: 'white',
          fontWeight: 'bold',
          '&:hover': { backgroundColor: '#45a049' }
        }}
      />
      <Chip
        label={`${draws}D`}
        size={size}
        clickable={false}
        onClick={() => {}}
        sx={{ 
          fontSize: '0.7rem', 
          height: '24px',
          backgroundColor: '#ff9800',
          color: 'white',
          fontWeight: 'bold',
          '&:hover': { backgroundColor: '#e68900' }
        }}
      />
      <Chip
        label={`${losses}L`}
        size={size}
        clickable={false}
        onClick={() => {}}
        sx={{ 
          fontSize: '0.7rem', 
          height: '24px',
          backgroundColor: '#f44336',
          color: 'white',
          fontWeight: 'bold',
          '&:hover': { backgroundColor: '#d32f2f' }
        }}
      />
      <Chip
        label={`${goalsFor}GF`}
        size={size}
        clickable={false}
        onClick={() => {}}
        sx={{ 
          fontSize: '0.7rem', 
          height: '24px',
          backgroundColor: '#2196f3',
          color: 'white',
          fontWeight: 'bold',
          '&:hover': { backgroundColor: '#1976d2' }
        }}
      />
      <Chip
        label={`${goalsAgainst}GA`}
        size={size}
        clickable={false}
        onClick={() => {}}
        sx={{ 
          fontSize: '0.7rem', 
          height: '24px',
          backgroundColor: '#9c27b0',
          color: 'white',
          fontWeight: 'bold',
          '&:hover': { backgroundColor: '#7b1fa2' }
        }}
      />
    </Box>
  );
};

export default TeamStatsChips;